<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
  <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Temporadas {{negocio.negocio}}</h1>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Temporada se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Temporada se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Temporada se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="Temporadas"
      sort-by="temporada"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Temporadas</v-toolbar-title>
          <v-progress-circular
        indeterminate
        v-if="progr == true"
        color="primary"
      ></v-progress-circular>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Temporada</v-btn>
            </template>
            <v-card  color="#393E46">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.temporada" label="Nombre"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card  color="#393E46">
          <v-card-title class="headline">Desea eliminar esta Temporada?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>

      </template>
      <template v-slot:[`item.dactiva`]="{ item }">
        <v-switch v-model="item.activa" @click="activaItem(item)" ></v-switch>
      </template>
      <template v-slot:[`item.dlistasactiva`]="{ item }">
        <v-switch v-model="item.listas" @click="activaItem(item)" ></v-switch>
      </template>
      <template v-slot:[`item.dinscripcionactiva`]="{ item }">
        <v-switch v-model="item.inscripcion" @click="activaItem(item)" ></v-switch>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dameTemporadas">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import md5 from "js-md5";
import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Temporadas | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {},
      token:'',
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Temporadas',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Temporadas: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        activa: true,
        createdAt: "2020-10-15 16:28:02",
        id: 50,
        inscripcion: false,
        listas: true,
        negocio: {},
        temporada: ""
    },
    defaultItem: {
      activa: true,
      createdAt: "2020-10-15 16:28:02",
      id: 50,
      inscripcion: false,
      listas: true,
      negocio: {},
      temporada: "Temporada 2020"
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Temporada', align: 'left',  value: 'temporada'},
        { text: 'Negocio', value: 'negocio.negocio' },
        { text: 'Activa', value: 'dactiva' },
        { text: 'Listas', value: 'dlistasactiva' },
        { text: 'Inscripcion', value: 'dinscripcionactiva' },
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    if (this.usuario.id === undefined){

      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.dameTemporadas();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.dameTemporadas();
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     "$store.state.cliente": function (){
       this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
       this.dameTemporadas();
     },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else{
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.dameTemporadas();
      }

    },
  },
  methods : {
    dameTemporadas(){
      this.progr = true;
            let urlTemporada = 'temporadas/negociotag/' + this.idnegocio  ;
        axios
        .get(urlTemporada,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Temporadas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        });
    },
    activaItem (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));

      axios
      .post('temporadas/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.editedIndex = this.Temporadas.indexOf(item);
               this.Temporadas = response.data;

      })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    editItem (item) {
      this.editedIndex = this.Temporadas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Temporadas.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      let md555 = md5(this.Temporadas[this.editedIndex].temporadaId.toString());
      axios
      .delete('temporadas/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.Temporadas = response.data;

      })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Temporadas[this.editedIndex], this.editedItem);
        this.editedItem.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.negocio.cliente.createdAt))
        this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))

        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('temporadas/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
          this.Temporadas = response.data;
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();
        this.editedItem.negocio = this.negocio
        this.editedItem.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.negocio.cliente.createdAt))
        this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('temporadas/editar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
          this.Temporadas = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Temporada' : 'Editar Temporada'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
